import { Suspense } from "react";
import { Outlet } from "react-router";
import { Box, Stack } from "@mui/material";
import { MainLayoutErrorBoundary } from "components/common/ErrorBoundaries";
import GlobalBanner from "components/common/GlobalBanner";
import GlobalNavigation from "components/common/GlobalNavigation";
import Loading from "components/shared/Loading";
import { JIRA_BUTTON_SIZE } from "theme/theme.constants";
import useGlobalNavigation from "./hooks/useGlobalNavigation";
import useSkipWidgetLayout from "./hooks/useSkipWidgetLayout";
import styles from "./MainLayout.styles";

const MainLayout = () => {
  const { isGlobalNavigationVisible } = useGlobalNavigation();
  const { isWidgetLayoutSkipped } = useSkipWidgetLayout();

  const contentStyles = {
    pb: isWidgetLayoutSkipped ? 0 : JIRA_BUTTON_SIZE,
    ...styles.content,
  };

  return (
    <Stack spacing={0} direction="row">
      <GlobalNavigation isVisible={isGlobalNavigationVisible} />
      <Box component="main" sx={contentStyles}>
        <GlobalBanner dismissible />
        <Suspense fallback={<Loading />}>
          <MainLayoutErrorBoundary>
            <Outlet />
          </MainLayoutErrorBoundary>
        </Suspense>
      </Box>
    </Stack>
  );
};

export default MainLayout;
